import * as React from 'react';
import { IReportOption } from '../../data/providers/reports/reportOptions';
import { AsymmetrySettings } from './asymmetry/settings/Settings';
import { BlockSettings } from './block/settings/Settings';
import { ComparisonReportSettings } from './comparison/settings/Settings';
import { DSISettings } from './dsi/settings/Settings';
import { EurSettings } from './eur/settings/Settings';
import { ProfileSettings } from './profile/settings/Settings';
import { QuadrantSettings } from './quadrant/settings/Settings';
import { RatioSettings } from './ratio/settings/Settings';
import { TrendSettings } from './trend/settings/Settings';
import { TsaSettings } from './tsa/settings/Settings';
import { WeightSettings } from './weight/settings/Settings';

interface IProps {
  report: IReportOption;
  setLoading: (v: boolean) => void;
}

/**
 * @description determines the correct settings button to render based on the supplied report option
 * @param props
 */
export const ReportSettings = (props: IProps): React.ReactElement => {
  const onSave = (): void => props.setLoading(true);
  switch (props.report?.id) {
    case 'trend':
      return <TrendSettings onSave={onSave} />;

    case 'profile':
      return <ProfileSettings onSave={onSave} />;

    case 'dsi':
      return <DSISettings onSave={onSave} />;

    case 'eur':
      return <EurSettings onSave={onSave} />;

    case 'ratio':
      return <RatioSettings onSave={onSave} />;

    case 'comparison':
      return <ComparisonReportSettings onSave={onSave} />;

    case 'block':
      return <BlockSettings onSave={onSave} />;

    case 'weight':
      return <WeightSettings onSave={onSave} />;

    case 'quadrant':
      return <QuadrantSettings onSave={onSave} />;

    case 'tsa':
      return <TsaSettings onSave={onSave} />;

    case 'asymmetry':
      return <AsymmetrySettings onSave={onSave} />;

    default:
      return null;
  }
};
